import { render, staticRenderFns } from "./privilegeOrder.vue?vue&type=template&id=ab0352e2&scoped=true&"
import script from "./privilegeOrder.vue?vue&type=script&lang=js&"
export * from "./privilegeOrder.vue?vue&type=script&lang=js&"
import style0 from "./privilegeOrder.vue?vue&type=style&index=0&id=ab0352e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0352e2",
  null
  
)

export default component.exports